import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  title: "Experience iYuga on Desktop",
  description: "",
};

const mobileViewDialogSlice = createSlice({
  name: "mobileViewDialog",
  initialState,
  reducers: {
    openMobileViewDialog: (state, action) => {
      state.isOpen = true;
      if (action.payload?.title) {
        state.title = action.payload.title;
      }
      if (action.payload?.description) {
        state.description = action.payload.description;
      }
    },
    closeMobileViewDialog: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openMobileViewDialog, closeMobileViewDialog } =
  mobileViewDialogSlice.actions;
export default mobileViewDialogSlice.reducer;
